class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    // Initialize variant input for pre-checked options
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
      this.updatePickupAvailability();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    if (!this.currentVariant) return;
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.remove('hide-selectore-button');
      });
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.add('hide-selectore-button');
      });
    }else{
      // if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
      //   chooseCart.classList.add('hide-selectore-button');
      // });
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.remove('hide-selectore-button');
      });
    }
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const id_new = `price-btn-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      const destinationNew = document.getElementById(id_new);
      const sourceNew = html.getElementById(id_new);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if (sourceNew && destinationNew) destinationNew.innerHTML = sourceNew.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] .product-add-text');
    if (!addButton) return;
    if(this.currentVariant != undefined){
      if(this.currentVariant.available){
        productForm.querySelector(".choose-cart").classList.remove('variant_sold-out');
      }else{
        productForm.querySelector(".choose-cart").classList.add('variant_sold-out');
      }
    }
    if (!modifyClass) return;
  }
  updatePickupAvailability() {
    const pickupEl = document.querySelector('pickup-status');
    if (!pickupEl || !this.currentVariant) return;
    pickupEl.update(this.currentVariant.id);
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] .product-add-text');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  const closeAll = () => {
    document.querySelectorAll('.dropdown-wrap.active').forEach(d => {
      d.classList.remove('active');
      document.body.classList.remove('active-variant');
      const list = d.querySelector('.variant-dropdown-list');
      if (list) list.style.height = '';
    });
  };
  document.querySelectorAll('.dropdown-wrap').forEach(dropdown => {
    const btn = dropdown.querySelector('.variant-dropdown');
    const list = dropdown.querySelector('.variant-dropdown-list');
    const radios = dropdown.querySelectorAll('input[type="radio"]');
    if (!btn || !radios.length) return;
    
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      
      // If only one option exists, don't open dropdown
      if (radios.length === 1) {
        return;
      }
      
      if (!dropdown.classList.contains('active')) closeAll();
      dropdown.classList.toggle('active');
      document.body.classList.toggle('active-variant', dropdown.classList.contains('active'));
      list.style.height = dropdown.classList.contains('active') ? list.querySelector('ul').offsetHeight + 'px' : '';
    });
    radios.forEach(r => r.addEventListener('change', e => {

      dropdown.classList.remove('active');
      document.body.classList.remove('active-variant');
      list.style.height = '';
      const txt = dropdown.querySelector('.selected_variant');
      if (txt) txt.innerHTML = e.target.dataset.val;
    }));
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.dropdown-wrap')) closeAll();
  });
}
variant_drodown();
document.addEventListener("shopify:section:load", variant_drodown);
class PickupStatus extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.productId = this.dataset.productId;
    this.variantId = this.dataset.variantId || null;
  }
  update(variantId) {
    if (!variantId || !this.sectionId) return;
    fetch(`${window.location.pathname}?variant=${variantId}&section_id=${this.sectionId}`)
      .then(response => response.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newStatus = doc.querySelector('#PickupStatus');
        if (newStatus) {
          this.innerHTML = newStatus.innerHTML;
          this.className = newStatus.className;
        }
      })
      .catch(e => console.error('Pickup status update failed:', e));
  }
}
customElements.define('pickup-status', PickupStatus);

function handleAddToCart(buttonSelector, redirectToCheckout = false) {
  const button = document.querySelector(buttonSelector);
  if (!button) return;
  button.addEventListener('click', function (evt) {
    evt.preventDefault();
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const cartform = button.closest('form');
    const formData = new FormData(cartform);
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        const errorEl = document.querySelector('.product-form-error');
        if (response.status) {
          if (errorEl) {
            errorEl.innerHTML = response.description;
            setTimeout(() => {
              errorEl.innerHTML = '';
            }, 2000);
          }
          return;
        }
        if (redirectToCheckout) {
          window.location.href = '/checkout';
        } else {
          if (typeof load_cart === 'function') {
            load_cart();
            setTimeout(() => {
              document.querySelector('body').classList.add('open-drawer');
            }, 500);
          } else {
            window.location.href = '/cart';
          }
        }
      })
      .catch((e) => console.error(e));
  });
}
handleAddToCart('.pdp-apple-checkout', true);
handleAddToCart('.product-addcart', false);

// document.querySelector('.product-addcart').addEventListener('click',function(evt){
//   evt.preventDefault();
//   const config = fetchConfig('javascript');
//   config.headers['X-Requested-With'] = 'XMLHttpRequest';
//   delete config.headers['Content-Type'];
//   var cartform = document.querySelector('.product-addcart').closest('form');
//   const formData = new FormData(cartform);  
//   config.body = formData;
//   fetch(`${routes.cart_add_url}`, config)
//   .then((response) => response.json())
//   .then((response) => {
//     if (response.status) {
//       document.querySelector('.product-form-error').innerHTML = response.description;
//       setTimeout(function(e){
//         document.querySelector('.product-form-error').innerHTML  = '';
//       },2000);
//       return;
//     }else{
//       if(typeof load_cart == 'function'){
//         load_cart();
//         setTimeout(function(e){
//           document.querySelector('body').classList.add('open-drawer');
//         },500);
//       }else{
//         window.location.href = "/cart";
//       }
//     }
//   })
//   .catch((e) => {
//     console.error(e);
//   })
//   .finally(() => {

//   });
// });
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelectorAll('.choose-selector a, .choose-selector .espress-checkout-button-selector')) document.querySelectorAll('.choose-selector a, .choose-selector .espress-checkout-button-selector').forEach(choose_selector => {
  choose_selector.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('.option-wrap:not(.d-none) .variant-dropdown').click();
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector(".media-slider"),
        indicator = document.querySelector(".scroll-indicator"),
        track = document.querySelector(".scroll-indicator-wrapper");
  let isDrag = false, startY, startScroll, swiper, init = false;
  const updateIndicator = () => {
    if (!grid || !indicator) return;
    const top = grid.offsetTop,
          h = grid.scrollHeight,
          vh = window.innerHeight,
          y = window.scrollY - top,
          max = h - vh,
          progress = Math.min(Math.max(y / max, 0), 1),
          th = track.offsetHeight - indicator.offsetHeight;
    indicator.style.transform = `translateY(${progress * th}px)`;
  };
  const startDrag = e => { isDrag = true; startY = e.clientY; startScroll = window.scrollY; indicator.style.transition = "none"; };
  const onDrag = e => {
    if (!isDrag) return;
    const top = grid.offsetTop, h = grid.scrollHeight, vh = window.innerHeight,
          th = track.offsetHeight - indicator.offsetHeight,
          delta = e.clientY - startY,
          scroll = startScroll + (delta / th) * (h - vh);
    window.scrollTo({ top: top + Math.min(Math.max(scroll - top, 0), h - vh), behavior: "auto" });
  };
  const stopDrag = () => { isDrag = false; indicator.style.transition = "transform .1s linear"; };
  const enableScroll = () => {
    document.addEventListener("scroll", updateIndicator);
    indicator.addEventListener("mousedown", startDrag);
    document.addEventListener("mousemove", onDrag);
    document.addEventListener("mouseup", stopDrag);
    updateIndicator();
  };
  const disableScroll = () => {
    document.removeEventListener("scroll", updateIndicator);
    indicator.removeEventListener("mousedown", startDrag);
    document.removeEventListener("mousemove", onDrag);
    document.removeEventListener("mouseup", stopDrag);
  };
  const enableSwiper = () => {
    if (init) return;
    init = true;
    swiper = new Swiper(".media-nav", {
      loop: false,
      spaceBetween: 0,
      a11y: false,
      navigation: {
        nextEl: '.media-slider .swiper-button-next',
        prevEl: '.media-slider .swiper-button-prev',
        enabled: false
      },
      // Enable navigation only on mobile via Swiper breakpoints
      breakpoints: {
        // 0-991px: enable navigation
        0: {
          navigation: { enabled: true }
        },
        // 992px and up: disable navigation
        992: {
          navigation: { enabled: false }
        }
      },
      scrollbar: {
        el: ".media-slider .swiper-scrollbar",
      },
      // pagination: {
      //   el: ".media-slider .swiper-pagination",
      //   type: "progressbar"
      // },
    });
  };
  const disableSwiper = () => { if (init && swiper) { swiper.destroy(true, true); init = false; } };
  const responsive = () => {
    if (window.innerWidth >= 992) { disableSwiper(); enableScroll(); }
    else { disableScroll(); enableSwiper(); }
  };
  responsive();
  window.addEventListener("resize", responsive);
  document.addEventListener("shopify:section:load", responsive);
});


// document.querySelectorAll('.product-info').forEach(grid => {
//   const meta = grid.querySelector('.snippet-addto-cart');
//   const priceAttr = meta?.getAttribute('data-price');
//   if (!priceAttr) return; 
//   const price = parseFloat(priceAttr) * 10;
//   const flcDiv = grid.querySelector('.flc-point');
//   if (flcDiv) {
//     const newDiv = document.createElement('div');
//     newDiv.className = 'new-price';
//     newDiv.textContent = `${price} FLC`;
//     flcDiv.appendChild(newDiv);
//   }
// });

document.addEventListener('DOMContentLoaded', function() {
  function updateExpectedDate() {
    var editorParagraph = document.querySelector('.ql-editor p');
    var expectedDateSpan = document.querySelector('.expected-date');
    var outOfStockMessage = document.querySelector('#oos-message-widget');
    if (editorParagraph && expectedDateSpan) {
      expectedDateSpan.textContent = editorParagraph.textContent;
      expectedDateSpan.style.filter = 'blur(0)';
    } else if (outOfStockMessage && expectedDateSpan) {
      expectedDateSpan.textContent = outOfStockMessage.textContent;
      expectedDateSpan.style.filter = 'blur(0)';
    }
  }

  setTimeout(updateExpectedDate, 1000);

  var eddContainers = document.querySelectorAll('.ns-edd-product-page');
  if (eddContainers.length) {
    var debounceTimer;
    var observer = new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateExpectedDate, 100);
    });
    eddContainers.forEach(function(container) {
      observer.observe(container, { childList: true, subtree: true, characterData: true });
    });
  }
});


if (document.querySelector('.pdp-apple-btn') !== null) {
  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }
  if (isIOS()) {
    document.querySelectorAll('.pdp-apple-btn').forEach(button => {
      button.addEventListener('click', function() {
        document.querySelectorAll('.variant-dropdown-list').forEach(list => {
          list.classList.toggle('ios-click');
        });
      });
    });
  }
}






// document.addEventListener('change', function(e) {
//   if (e.target.matches('.variant-dropdown-list.ios-click .variant-avi input[type="radio"]')) {
//     alert('change');
//     const form = e.target.closest('form');
//     const formData = new FormData(form);
//     fetch(form.action, {
//       method: form.method,
//       body: formData
//     })
//     .then(response => {
//       if (response.ok) {
//         window.location.href = '/checkout';
//       } else {
//         console.error('Form submission failed.');
//       }
//     })
//     .catch(error => {
//       console.error('Error:', error);
//     });
//   }
// });
document.addEventListener('change', function(e) {
  if (e.target.matches('.variant-dropdown-list.ios-click .variant-avi input[type="radio"]')) {
    const form = e.target.closest('form');
    const formData = new FormData(form);

    setTimeout(() => {
      // iOS compatible background submit
      if (navigator.sendBeacon) {
        navigator.sendBeacon(form.action, formData);
      } else {
        fetch(form.action, {
          method: form.method,
          body: formData
        });
      }

      // Safe redirect after small delay
      setTimeout(() => {
        window.location.href = '/checkout';
      }, 200);
    }, 500);
  }
});


document.querySelectorAll('.snippet-product-variant-selector .variant-dropdown-list .variant-unavailable a')
  .forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      const li = link.closest('li');
      const input = li ? li.querySelector('input') : null;
      if (input) {
        input.click();
      }
      setTimeout(() => {
        const soldOutBtn = document.querySelector('.snippet-addto-cart .klaviyo-bis-trigger');
        if (soldOutBtn) {
          soldOutBtn.click();
        }
      }, 1000);
    });
  });

